export enum Permissions {
    CREATE_ANY_BUSINESS = 'create:any_business',
    READ_ANY_BUSINESS = 'read:any_business',
    UPDATE_ANY_BUSINESS = 'update:any_business',
    DELETE_ANY_BUSINESS = 'delete:any_business',

    CREATE_OWN_BUSINESS = 'create:own_business',
    READ_OWN_BUSINESS = 'read:own_business',
    UPDATE_OWN_BUSINESS = 'update:own_business',
    DELETE_OWN_BUSINESS = 'delete:own_business',

    CREATE_ANY_WORKSPACE = 'create:any_workspace',
    READ_ANY_WORKSPACE = 'read:any_workspace',
    UPDATE_ANY_WORKSPACE = 'update:any_workspace',
    DELETE_ANY_WORKSPACE = 'delete:any_workspace',

    CREATE_OWN_WORKSPACE = 'create:own_workspace',
    READ_OWN_WORKSPACE = 'read:own_workspace',
    UPDATE_OWN_WORKSPACE = 'update:own_workspace',
    DELETE_OWN_WORKSPACE = 'delete:own_workspace',

    READ_BUSINESS_SETTINGS = 'read:business_settings',
    UPDATE_BUSINESS_SETTINGS = 'update:business_settings',

    READ_MEMBERS_SETTINGS = 'read:members_settings',
    UPDATE_MEMBERS_SETTINGS = 'update:members_settings',

    READ_BILLING_SETTINGS = 'read:billing_settings',
    UPDATE_BILLING_SETTINGS = 'update:billing_settings',
}
